<div class="row mb-2">
    <div class="col pl-0">
        <div widget class="card border-0 box-shadow">
            <div class="card-body widget-body pb-0 pt-2 mb-4">
                <div class="row">
                    <div class="col-lg-6">
                        <button type="button" class="btn blue-btn btn-sm  mr-2  mb-1" data-bs-target="#SaveorUpdatemodal"
                            data-bs-toggle="modal">
                            Add QR Image
                        </button>
                    </div>
                </div>
                <!-- gridQR -->
                <div class="row">
                    <div class="col-lg-12">
                        <ejs-grid #gridQR [dataSource]="QRList" allowPaging="true" [pageSettings]='initialPage'
                            [allowFiltering]="false">
                            <e-columns>
                                <e-column minWidth="200" headerText="Action" uid="action" textAlign="center"
                                    [showInColumnChooser]="false">
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table text-center mr-2"
                                            (click)="GetQrcodeImage(data)">
                                            <i class="fa fa-download"></i>
                                        </button>
                                        <button class="btn btn-delete-table mr-2 text-center"
                                            data-bs-target="#modalQRdelete" data-bs-toggle="modal" (click)="setQRId(data)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
                <div *ngIf="QRList.length == 0" class="text-center" style="color:red">
                    <p>No data available</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- SaveorUpdatemodal -->
<span id="openQRModal" data-bs-target="#SaveorUpdatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="SaveorUpdatemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="saveQR.id=='00000000-0000-0000-0000-000000000000'"> Add
                        QR </span>
                    <span *ngIf="saveQR.id!='00000000-0000-0000-0000-000000000000'">Update QR </span>
                </h5>
                <button type="button" class="close" (click)="openDialog()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <label style="font-weight: 600;margin-top:6px;">Image
                        </label>
                    </div>
                    <div class="col-lg-6">
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" accept="image/png, image/gif, image/jpeg"
                                [(ngModel)]="saveQR.qrImage" id="customFile" name="filename"
                                (change)="onFileUpload($event);">
                            <label class="custom-file-label" for="customFile">Choose Image</label>
                            <label for="customFile" style="color:#004290">{{fileName}}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 ">
                        <p style="color: red">Note:uploaded image will be reflected in invoice and spenddown report</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="saveQR.qrImage==null || saveQR.qrImage==undefined || saveQR.qrImage=='' ||
                    validatingFile" (click)="SaveOrUpdateQR();"><span *ngIf="saveQR.id=='00000000-0000-0000-0000-000000000000'"> Save &
                        Close</span>
                    <span *ngIf="saveQR.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span>
                </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialog()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete -->
<span id="openDelete" data-bs-toggle="modal" data-bs-target="#modalQRdelete"></span>
<div class="modal fade" id="modalQRdelete" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteQRDetails()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeDeleteModal()">No</button>
            </div>
        </div>
    </div>
</div>